import './utils/setupResizeObserver';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'd3-transition';
import { BrowserRouter as Router } from 'react-router-dom';
import IDSThemeProvider from 'apollo-react/utils/IDSThemeProvider';
import App from './App';
import 'react-toastify/dist/ReactToastify.css';
import { LicensingExperienceProvider } from './contexts/LicensingExperienceContext';
// import { AuthProvider } from "./Contexts/Auth.js";

// Initialize Bugsnag
import './bugsnag';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <IDSThemeProvider themeName="IDS">
    <React.StrictMode>
      <Router>
        {/* <AuthProvider> */}
        <LicensingExperienceProvider>
          <App />
        </LicensingExperienceProvider>
        {/* </AuthProvider> */}
      </Router>
    </React.StrictMode>
  </IDSThemeProvider>
);
